<h4
  class="tile-title"
  [tooltip]="titleTooltip"
  [placement]="display ? display : 'bottom'"
  container="body"
>
  {{ title }}
  <img [src]="'../../assets/images/no_data.png'" class="more-info-icon" />
</h4>
<ng-template #titleTooltip>
  <span>
    <span class="title-tooltip title tooltip_title">
      {{ title }}
    </span>
    <div *ngIf="definition">
      <span class="title-tooltip definition tooltip_text">
        <span *ngIf="level !== 'student' && level !== 'usage'"
          >Defined as {{ decapitalize(definition) }}</span
        >
        <span *ngIf="level === 'student' || level === 'usage'">{{
          definition
        }}</span>
      </span>
    </div>
    <div *ngIf="source">
      <span class="title-tooltip source"
        ><em>Source: {{ source }}</em></span
      >
    </div>
  </span>
</ng-template>
